import { useTranslation } from 'react-i18next'

import { usePageBrowserTabTitle } from '../../../hooks'
import { Auth } from '../Auth'
import { useAuthRedirectLoggedUser } from '../Auth.hooks'

import { LoginForm } from './LoginForm'

function Login() {
  useAuthRedirectLoggedUser()

  const { t } = useTranslation()

  usePageBrowserTabTitle({ pageTitle: t('BrowserTab.LoginPageTitleKey') })

  return (
    <Auth>
      <LoginForm />
    </Auth>
  )
}

export default Login
